import styled from 'styled-components';

export const ProvideQuantityByContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

export const WireItensTableContainer = styled.div`
  &.wire-weight {
    display: flex;
    align-items: center;
  }
`;

export const WireItensTableSpan = styled.span<{ $disabled: boolean }>`
  cursor: ${($disabled) => ($disabled ? 'default' : 'pointer')};
`;

export const TableContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 1.5rem;
  margin-bottom: 0.5rem;

  &:first-child {
    padding: 1rem;
  }
`;
